import React from 'react'
import ReactTooltip from 'react-tooltip'
import clsx from 'clsx'

// Each item: { id, label, complete, tooltip?, link? }
function ChecklistItem({ item }) {
  const tooltipId = item.tooltip ? `checklist-tooltip-${item.id}` : undefined

  const label = (
    <span
      className="dome-p2 dome-color-dark-grey"
    >
      {item.label}
      {item.tooltip && (
        <>
          {' '}
          <i
            className="fa fa-question-circle-o dome-color-secondary-green"
            data-tip
            data-for={tooltipId}
            style={{ cursor: 'default' }}
          />
          <ReactTooltip
            id={tooltipId}
            place="right"
            effect="solid"
            type="light"
            arrowColor="transparent"
            className='dome-rounded-border dome-light-shadow dome-width200'
          >
            <span className="dome-p3 dome-color-dark-grey">{item.tooltip}</span>
          </ReactTooltip>
        </>
      )}
    </span>
  )

  return (
    <li className="submit-application-package__checklist-item dome-d-flex dome-gap6 dome-align-center">
      <i
        className={clsx(
          'fa-solid fa-xs fa-circle-check',
          item.complete ? 'dome-color-secondary-green' : 'dome-color-disabled'
        )}
      />
      {item.link ? (
        <a href={item.link} className="dome-color-dark-grey">
          {label}
        </a>
      ) : (
        label
      )}
    </li>
  )
}

export function SubmissionChecklist({ items }) {
  if (!items || !items.length) return null

  return (
    <ul
      className="submit-application-package__checklist"
      style={{ margin: '6px 0 0 0', padding: 0, listStyle: 'none' }}
    >
      {items.map((item) => (
        <ChecklistItem key={item.id} item={item} />
      ))}
    </ul>
  )
}

export default SubmissionChecklist
